"use client";

import { Box } from "@mui/material";
import dynamic from "next/dynamic";
import { useState } from "react";
import Sidebar from "../src/components/sidebar/sidebar";
import Topbar from "../src/components/topbar/topbar";
import ProtectedRoute from "./ProtectedRoute";


export default function DashboardLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);

  return (
    <ProtectedRoute>
      <Box display="flex" minHeight="100vh" bgcolor="background.default" >
        <Sidebar
          mobileOpen={mobileOpen}
          desktopOpen={desktopOpen}
          onClose={() => setMobileOpen(false)}
        />

        <Box flex={1} sx={{ overflowY: "hidden" }}>
          <Topbar onMenuClick={() => setMobileOpen(true)} onDesktopMenuClick={() => setDesktopOpen(!desktopOpen)} desktopOpen={desktopOpen} />
          <Box p={{ xs: 2 }}>{children}</Box>
        </Box>
      </Box>

    </ProtectedRoute>

  );
}
